import LayoutHorizontalSidenav from '@/layout/LayoutHorizontalSidenav'

export default [{
  // Blank layout
  path: '/exercises',
  component: LayoutHorizontalSidenav,
  children: [
    {
      path: '',
      name: 'exercises',
      component: () => import('@/components/exercises/Exercises'),
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'new',
      name: 'newExercise',
      component: () => import('@/components/exercises/EditExercise'),
      meta: {
        requiresAuth: true
      }
    }, {
      path: ':id/edit',
      name: 'editExercise',
      component: () => import('@/components/exercises/EditExercise'),
      meta: {
        requiresAuth: true
      },
      props: true
    }
  ]
}]
